import script from "./MemberNode.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberNode.vue?vue&type=script&setup=true&lang=ts"

import "./MemberNode.vue?vue&type=style&index=0&id=466b0d73&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-466b0d73"]])

export default __exports__